function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React from "react";
import { Field } from "react-final-form";
import { TextField, FormHelperText, Autocomplete } from "@mui/material";
export default function SearchableSelectField(_param) {
    var name = _param.name, validate = _param.validate, label = _param.label, options = _param.options, placeholder = _param.placeholder, multiple = _param.multiple, extraAutocompleteProps = _object_without_properties(_param, [
        "name",
        "validate",
        "label",
        "options",
        "placeholder",
        "multiple"
    ]);
    var handleChange = React.useCallback(function(onChange) {
        return function(e, selectedValue) {
            if (Array.isArray(selectedValue)) {
                onChange(selectedValue.map(function(param) {
                    var value = param.value;
                    return value;
                }));
            } else {
                onChange(selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.value);
            }
        };
    }, []);
    var getSelectedValueOptions = React.useCallback(function(value) {
        var isMultiple = Array.isArray(value) || multiple;
        var selectedValues = options.filter(function(param) {
            var optionValue = param.value;
            if (isMultiple) {
                return value.includes(optionValue);
            } else {
                return value === optionValue;
            }
        });
        var _selectedValues_;
        return isMultiple ? selectedValues : (_selectedValues_ = selectedValues[0]) !== null && _selectedValues_ !== void 0 ? _selectedValues_ : null;
    }, [
        options,
        multiple
    ]);
    return /*#__PURE__*/ _jsx(Field, {
        name: name,
        validate: validate,
        children: function(param) {
            var _param_input = param.input, onChange = _param_input.onChange, name = _param_input.name, value = _param_input.value, meta = param.meta;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Autocomplete, _object_spread_props(_object_spread({
                        autoComplete: true,
                        size: "small"
                    }, extraAutocompleteProps), {
                        multiple: multiple,
                        options: options,
                        getOptionLabel: function(param) {
                            var label = param.label;
                            return label;
                        },
                        renderInput: function(params) {
                            return /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({}, params), {
                                name: name,
                                label: label,
                                placeholder: placeholder,
                                inputProps: _object_spread({}, params.inputProps)
                            }));
                        },
                        onChange: handleChange(onChange),
                        value: getSelectedValueOptions(value)
                    })),
                    /*#__PURE__*/ _jsx(FormHelperText, {
                        error: true,
                        children: meta.error ? meta.error : ""
                    })
                ]
            });
        }
    });
}
